<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <SearchableSelect
    v-model="inputValue"
    v-bind="$attrs"
    :label="label"
    :tooltip="tooltip"
    :warning="warning"
    :is-error="!!errorMessage"
    :placeholder="placeholder"
    :hint="hint"
    :options="options"
    :disabled="disabled"
    :track-by="trackBy"
  />
  <AiValidation :field-name="name">
    <template #displayValue="{ value }">
      <p>
        {{ options.find((o) => o.value === value)?.label ?? value }}
      </p>
    </template>
  </AiValidation>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed } from 'vue';
import AiValidation from '@/components/AiValidation.vue';
import SearchableSelect, { type SearchableSelectOptionData } from './SearchableSelect.vue';

export type SelectOptionData = SearchableSelectOptionData;

const props = defineProps<{
  name: string;
  label?: string;
  placeholder?: string;
  hint?: string;
  options: SelectOptionData[];
  tooltip?: string;
  warning?: string;
  disabled?: boolean;
  trackBy?: string[];
}>();

const hint = computed(() => errorMessage.value || props.hint);

const { value: inputValue, errorMessage } = useField<string | number | undefined>(
  props.name,
  undefined,
);
</script>
